// extracted by mini-css-extract-plugin
export var style = "block-projects-mobile-module--style--2DgBq";